<ng-container *ngIf="show">
	<div class="dp-backdrop" (click)="onBackdropTap()"></div>
</ng-container>
